import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const newsletterApi = createApi({
  reducerPath: 'newsletterApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_NEWSLETTER_API,
  }),
  endpoints: (build) => ({
    signupNewsletter: build.mutation<void, { email: string }>({
      query: ({ email }) => ({
        url: 'KlaviyoProjectbrxWebsiteNewsletter',
        method: 'POST',
        body: {
          apikey: process.env.REACT_APP_NEWSLETTER_API_KEY,
          email,
        },
      }),
    }),
  }),
});

export const { useSignupNewsletterMutation } = newsletterApi;
